import { useAppTheme } from "@hooks/useAppTheme";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";

// Single source of typography for scenario body copy so the intro card and
// context panel render authored markdown identically.
export const ScenarioMarkdown = ({
	text,
	fontSize = 14,
	paragraphSpacing = 0,
}: {
	text: string;
	fontSize?: number;
	paragraphSpacing?: number;
}) => {
	const theme = useAppTheme();
	return (
		<CustomMarkdownRenderer
			text={text}
			fontSize={fontSize}
			paragraphMarginVertical={paragraphSpacing}
			customStyles={{
				text: {
					color: theme.colors.onSurface,
				},
			}}
		/>
	);
};
